import { Link  } from 'react-router-dom';

import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';
import ExploreIcon from '@mui/icons-material/Explore';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AddBoxIcon from '@mui/icons-material/AddBox';

// import mobileLogo from '../../assets/tiktaka_logo_mobile.png';

import LoginIcon from '@mui/icons-material/Login';

const MobileTopBar = () => {

    return (

        <div className='mobileTopBar'>
          <div className='navLinkMobile'>
            <Link to='/home'><div className='navIconTop'>
            <HomeIcon sx={{fontSize:'30px', margin:'0 20px 0 0'}} />
            </div></Link>
            <Link to='/search'><div className='navIconTop'>
            <SearchIcon sx={{fontSize:'30px', margin:'0 20px 0 0'}} />
            </div></Link>
            <Link to='/explore'><div className='navIconTop'>
            <ExploreIcon sx={{fontSize:'30px', margin:'0 20px 0 0'}} />
            </div></Link>
            <Link to='/create'><div className='navIconTop'>
            <AddBoxIcon sx={{fontSize:'30px', margin:'0 20px 0 0'}} />
            </div></Link>
            <Link to='/notifications'><div className='navIconTop'>
            <NotificationsIcon sx={{fontSize:'30px', margin:'0 20px 0 0'}} />
            </div></Link>
            <Link to='/reels'><div className='navIconTop'>
            <PlayArrowIcon  sx={{fontSize:'30px', margin:'0 20px 0 0'}} />
            </div></Link>
            <Link to='/login'><div className='navIconTop'>
            <LoginIcon sx={{fontSize:'30px', margin:'0 20px 0 0'}} />
            {/* <img className='profileImgMobile' src={profileImgMobile} alt='profile' /> */}
            </div></Link>
          </div>  
       
        </div>


    );

};

export default MobileTopBar;